import React, { useEffect, useState } from "react";

import { VertTypography } from "@vertem-core/vertice-ds";

import { rulesFile } from "Constants/LikePlus";

const LikePlusRules = () => {
  const [rules, setRules] = useState([]);

  useEffect(() => {
    const loadRules = async () => {
      try {
        const module = await import(`./data/${rulesFile}`);
        const rules = module.default;

        setRules(rules);
      } catch (error) {
        console.error("Erro ao carregar os items do FAQ:", error);
      }
    };

    loadRules();
  }, []);

  return (
    <>
      {rules.map(rule => <VertTypography.Paragraph type="light">• {rule}</VertTypography.Paragraph>)}
    </>
  );
}

export default LikePlusRules;
